import React from 'react';
import ReactDOM from 'react-dom/client';

import { InmunetApp } from './InmunetApp';
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <InmunetApp />
  </React.StrictMode>
);